import {DecryptionManager} from './decryption';

export class DecryptionManagerSingleton {
  private static instance: DecryptionManager | null = null;

  static getDecryptionManager(): DecryptionManager | null {
    return DecryptionManagerSingleton.instance;
  }

  static setDecryptionManager(manager: DecryptionManager): void {
    DecryptionManagerSingleton.instance = manager;
  }

  static clearDecryptionManager(): void {
    DecryptionManagerSingleton.instance = null;
  }

  static isDecryptionEnabled(): boolean {
    return DecryptionManagerSingleton.instance?.isEnabled() ?? false;
  }
}
